(function () {
  const root = document.querySelector('[data-sizing-form]');
  if (!root) return;

  let errors;
  try {
    errors = JSON.parse(root.dataset.errorsJson || '{}');
  } catch (e) {
    errors = {};
  }

  const sizes = (root.dataset.sizes || '7,8,9,10,11,12,13').split(',').map(s => s.trim()).filter(Boolean);

  const labels = {
    ring: root.dataset.labelRing || 'Ring',
    size: root.dataset.labelSize || 'Ringgröße',
    sizePrefix: root.dataset.labelSizePrefix || 'Größe',
    summaryPrefix: root.dataset.summaryPrefix || 'Bestellung',
    placeholder: root.dataset.labelPlaceholder || 'Bitte wählen',
  };

  const lookupForm = root.querySelector('[data-sizing-lookup]');
  const selectForm = root.querySelector('[data-sizing-select]');
  const successBox = root.querySelector('[data-sizing-success]');
  const unitsHost = root.querySelector('[data-sizing-units]');
  const summary = root.querySelector('[data-sizing-summary]');
  const errBox = root.querySelector('[data-sizing-error]');
  const errBox2 = root.querySelector('[data-sizing-error-select]');
  const backBtn = root.querySelector('[data-sizing-back]');

  const state = { orderToken: null, orderName: null, email: null, units: [] };

  function showError(box, key) {
    box.textContent = errors[key] || errors.generic || 'Es ist ein Fehler aufgetreten.';
    box.hidden = false;
  }
  function clearError(box) {
    box.hidden = true;
    box.textContent = '';
  }

  function setLoading(btn, on) {
    if (!btn) return;
    if (on) {
      btn.classList.add('sizing-form__btn--loading');
      btn.disabled = true;
    } else {
      btn.classList.remove('sizing-form__btn--loading');
      btn.disabled = false;
    }
  }

  function buildUnitCard(index, productTitle, color, imageUrl) {
    const card = document.createElement('div');
    card.className = 'sizing-form__unit-card';

    const colorRow = document.createElement('div');
    colorRow.className = 'sizing-form__unit-color';

    if (imageUrl) {
      const img = document.createElement('img');
      img.src = imageUrl;
      img.alt = '';
      img.loading = 'lazy';
      img.className = 'sizing-form__unit-swatch';
      colorRow.appendChild(img);
    }

    const nameSpan = document.createElement('span');
    nameSpan.className = 'sizing-form__unit-name';
    const namePart = productTitle ? productTitle + ' - ' + color : color;
    nameSpan.textContent = labels.ring + ' ' + (index + 1) + ': ' + namePart;
    colorRow.appendChild(nameSpan);

    const label = document.createElement('label');
    label.className = 'sizing-form__label';

    const labelText = document.createElement('span');
    labelText.textContent = labels.size;

    const select = document.createElement('select');
    select.required = true;
    select.name = 'size_' + index;

    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = labels.placeholder;
    placeholder.disabled = true;
    placeholder.selected = true;
    select.appendChild(placeholder);

    for (const size of sizes) {
      const opt = document.createElement('option');
      opt.value = size;
      opt.textContent = labels.sizePrefix + ' ' + size;
      select.appendChild(opt);
    }

    label.appendChild(labelText);
    label.appendChild(select);
    card.appendChild(colorRow);
    card.appendChild(label);
    return card;
  }

  function renderSelection() {
    unitsHost.replaceChildren();
    state.units.forEach((u, i) => unitsHost.appendChild(buildUnitCard(i, u.productTitle, u.color, u.imageUrl)));
    summary.textContent = labels.summaryPrefix + ' ' + state.orderName;
    lookupForm.hidden = true;
    selectForm.hidden = false;
  }

  lookupForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearError(errBox);
    const fd = new FormData(lookupForm);
    const payload = { orderName: fd.get('orderName'), email: fd.get('email') };
    const submitBtn = lookupForm.querySelector('button[type="submit"]');
    setLoading(submitBtn, true);
    try {
      const res = await fetch('/apps/sizing/lookup', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!data.ok) return showError(errBox, data.error || 'generic');
      state.orderToken = data.orderToken;
      state.orderName = data.orderName;
      state.email = payload.email;
      state.units = data.units;
      renderSelection();
    } catch (err) {
      showError(errBox, 'network');
    } finally {
      setLoading(submitBtn, false);
    }
  });

  backBtn.addEventListener('click', () => {
    selectForm.hidden = true;
    lookupForm.hidden = false;
    clearError(errBox2);
  });

  selectForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearError(errBox2);
    const fd = new FormData(selectForm);
    const choices = state.units.map((u, i) => ({
      lineItemId: u.lineItemId,
      color: u.color,
      size: String(fd.get('size_' + i) || ''),
    }));
    if (choices.some(c => !c.size)) return showError(errBox2, 'incomplete');

    const submitBtn = selectForm.querySelector('button[type="submit"]');
    setLoading(submitBtn, true);
    try {
      const res = await fetch('/apps/sizing/submit', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ orderToken: state.orderToken, email: state.email, choices }),
      });
      const data = await res.json();
      if (!data.ok) return showError(errBox2, data.error || 'generic');
      selectForm.hidden = true;
      successBox.hidden = false;
    } catch (err) {
      showError(errBox2, 'network');
    } finally {
      setLoading(submitBtn, false);
    }
  });
})();
